import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import { IconButton, Switch, Icon } from '@material-ui/core'
import { Map } from 'immutable'
import React from 'react'
import ColumnCollection from 'types/table/ColumnCollection'
import Column from 'types/table/Column'
import { FeatureFlag } from 'types/featureFlags'
import { FEATURE_FLAGS_KEY } from 'constants/index'
import {
  fetchFeatureFlagsTable,
  clearFeatureFlagsTable,
  setFeatureFlagsInfo,
} from 'reducers/featureFlags/reducer'
import UrlHelper from 'helpers/url'
import withPromise from 'helpers/withPromise'
import * as AppRouter from 'constants/appRouting'
import { Flex } from 'components/common/styles'
import ListFromTable from 'components/common/ListFromTable'
import messages from '../translate'
import { FeatureFlagsTableProps } from './FeatureFlagsTable.types'

export class FeatureFlagsTable extends ListFromTable {
  constructor(props: FeatureFlagsTableProps) {
    super(props)
    // @ts-expect-error because of FuncHelper that we are using in ListFromTable
    this.getTableData = props.fetchFeatureFlagsTable
    // @ts-expect-error because of FuncHelper that we are using in ListFromTable
    this.clearReducerState = props.clearFeatureFlagsTable
    this.asyncData = true
    this.loadingData = false
  }

  shouldComponentUpdate(nextProps: FeatureFlagsTableProps) {
    this.loadingData = nextProps.loader
    const { tableData } = this.props

    if (tableData !== nextProps.tableData) {
      this.loadingData = false
    }

    return super.shouldComponentUpdate(nextProps)
  }

  getTableProps = () => {
    const {
      history: { goBack },
    } = this.props

    return {
      title: 'Feature Flags',
      showFilterBar: true,
      sorting: false,
      paging: false,
      searching: false,
      filtering: false,
      creating: false,
      goBack,
      dense: { enabled: false, state: false, handler: () => null },
    }
  }

  onSwitchChange = (featureFlag: FeatureFlag) => {
    const { setFeatureFlagsInfo } = this.props
    const { id: entityId, enabled, description, title, licensees } = featureFlag

    withPromise(setFeatureFlagsInfo, {
      entityId,
      values: {
        title,
        description,
        licensees: licensees.map(({ id }) => id),
        enabled: !enabled,
      },
    }).then(errors =>
      errors
        ? Promise.resolve(errors)
        : this.reloadTableData(AppRouter.FEATURE_FLAGS),
    )
  }

  getColumns = () => {
    const {
      intl: { formatMessage },
      history,
    } = this.props
    const columns = new ColumnCollection()

    columns.add(new Column('id', 'Id'))

    columns.add(new Column('key', formatMessage(messages.key)))
    columns.add(new Column('title', formatMessage(messages.title)))
    columns.add(new Column('description', formatMessage(messages.description)))

    columns.add(
      new Column('actions', '', {
        render: (featureFlag: FeatureFlag) => (
          <Flex align="center" justify="flex-end">
            <Switch
              color="primary"
              checked={featureFlag.enabled}
              onChange={() => this.onSwitchChange(featureFlag)}
            />
            <IconButton
              size="small"
              onClick={() =>
                history.push(
                  UrlHelper.create(AppRouter.FEATURE_FLAGS_EDIT, {
                    id: featureFlag.id,
                  }),
                )
              }>
              <Icon>edit</Icon>
            </IconButton>
          </Flex>
        ),
      }),
    )

    return columns
  }
}

export default connect(
  (state: {
    getIn: (path: Array<string>) => Map<string, FeatureFlag> | boolean
  }) => ({
    tableData: state.getIn([FEATURE_FLAGS_KEY, 'tableData']) as Map<
      string,
      FeatureFlag
    >,
    loader: state.getIn([FEATURE_FLAGS_KEY, 'isLoadTable']) as boolean,
  }),
  {
    fetchFeatureFlagsTable,
    clearFeatureFlagsTable,
    setFeatureFlagsInfo,
  },
  // @ts-expect-error types were not defined for ListFromTable, so let's ignore typescript errors with this Component
)(injectIntl(FeatureFlagsTable))
